import { render, staticRenderFns } from "./eventreport.html?vue&type=template&id=10514bc3&scoped=true&"
import script from "./eventreport.js?vue&type=script&lang=js&"
export * from "./eventreport.js?vue&type=script&lang=js&"
import style0 from "./eventreport.scss?vue&type=style&index=0&id=10514bc3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10514bc3",
  null
  
)

export default component.exports